import { appSlice } from './app.reducer';

export const {
  TOGGLE_LOADER,
  TOGGLE_SELECTED_PROGRAM,
  SET_USER_SELECTED_PROGRAMS,
  SET_SETTINGS_TIMEOUT_ID,
  SET_PROGRAM_WS_UPDATES,
  REMOVE_PROGRAM_WS_UPDATES,
  SET_NOTIFICATION_TYPE,
  SET_PROG_IN_FULLSCREEN,
  SET_NOTIFICATIONS,
  SET_HIGHLIGHTED_DATE,
  RESET_HIGHLIGHTED_DATES,
} = appSlice.actions;
